import { logoutApi } from "../services/auth.api";
import { useRouter, usePathname } from "next/navigation";
import { useLocale } from "next-intl";
import { clearImpersonationSession } from "../utils/impersonationSession";
import { useCurrentUser } from "../context/CurrentUserContext";
import { getRegionLocaleHref } from "@/services/region";

export function useLogout() {
  const router = useRouter();
  const locale = useLocale();
  const pathname = usePathname();
  const { user } = useCurrentUser();

  const handleLogout = async () => {
    // Capture the account context before logout clears the session, so a
    // teacher lands back on the teacher login page rather than the student one.
    const isTeacher = user?.account_type === "teacher";
    await logoutApi();
    clearImpersonationSession();
    router.push(getRegionLocaleHref(pathname, locale, isTeacher ? "/teacher/login" : "/login"));
  };

  return { handleLogout };
}
